import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Monroe, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Monroe post office can take 2–6 months. For healthcare professionals with conference deadlines, ULM students with study-abroad program orientations, and Northeast Louisiana families booking Caribbean cruises, that timeline is simply not viable.",
  },
  {
    q: "Can doctors and healthcare professionals in Monroe get expedited passports for medical conferences?",
    a: "Absolutely — healthcare professionals are one of our most common client types in Monroe. CME conferences in Vienna, London, Toronto, and Geneva often have late-addition slots confirmed with 3–6 weeks notice. We regularly process expedited renewals for St. Francis and Ochsner physicians who need their passports before an international conference. Contact us the moment your conference travel is confirmed.",
  },
  {
    q: "Can ULM students get passports quickly for study abroad or clinical rotations?",
    a: "Yes. University of Louisiana Monroe pharmacy, nursing, and health sciences students participate in international clinical rotations. Business and liberal arts students pursue exchange programs in Europe and Latin America. Many are first-time passport applicants who need guidance through the acceptance clerk process. We guide ULM students through the exact location, forms, and timeline so they do not miss their program orientation.",
  },
  {
    q: "How quickly can Monroe families get passports for a New Orleans cruise?",
    a: "Monroe families regularly book cruises from the Port of New Orleans (290 miles south). If your sailing is within 2–6 weeks, standard processing cannot meet your deadline. Fast Passport Center can process an expedited renewal or new passport in as little as 2–9 business days. Start your order as soon as you discover the issue — and check every family member's passport at the time of booking.",
  },
  {
    q: "Does Fast Passport Center have an office in Monroe?",
    a: "No — we operate remotely, which is why we can serve all of Northeast Louisiana without you driving to New Orleans or Houston. Start your order online, follow the checklist we provide, and ship your documents overnight from any UPS or FedEx location in Monroe or West Monroe. We handle the rest.",
  },
  {
    q: "What is the nearest regional passport agency to Monroe, LA?",
    a: "Monroe sits between two regional passport agencies — New Orleans (approximately 290 miles south) and Houston (approximately 300 miles southwest). Both require appointments that are often unavailable, and both require an in-person visit. Fast Passport Center eliminates the drive and the uncertainty entirely.",
  },
  {
    q: "What documents do I need for an expedited passport from Monroe?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function MonroeFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Monroe and Northeast Louisiana travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}